export default "__VITE_ASSET__CswKqvA$__"